import React from 'react'
import video1 from '../assets/v1.mp4'
import video2 from '../assets/v2.mp4'
import video3 from '../assets/v3.mp4'
import video4 from '../assets/v4.mp4'
import video5 from '../assets/v5.mp4'
import video6 from '../assets/v6.mp4'
import video7 from '../assets/v7.mp4'
import video8 from '../assets/v8.mp4'
import video9 from '../assets/v9.mp4'
import video10 from '../assets/v10.mp4'
import video11 from '../assets/v11.mp4'
import video12 from '../assets/v12.mp4'
import { useTranslation } from "react-i18next";

export default function VideoMaruzalar() {
  const { t } = useTranslation();
  
  return (
    <section className='VideoMaruzalar'>
      <div className="container">
        <h2 className="tittle">{t('tinglovchilar2')}</h2>
        <div className="row">
          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video1}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video2}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video3}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video4}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video5}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video6}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video7}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video8}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video9}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video10}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video11}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          <div className='col-md-6'>
            <video
              className='video mb-3'
              src={video12}
              controls
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Your browser does not support the video tag.
            </video>
          </div>

          

        </div>
      </div>
    </section>
  )
}